import { mergeDeep } from "../../../../utils/Helper";
import { Mode } from "../../../../utils";
import { validation } from "../Custody";
import { CustodyIntStatus } from "../../../Custody/types";

export const custodyReducer = (state, action) => {
  switch (action.type) {
    case "CHANGE_MODE":
      switch (action.mode) {
        case Mode.EDIT:
          return processEdit(state);
        case Mode.PRECHECK:
          return processPrecheck(state);
        case Mode.CONFIRM:
          return processConfirm(state);
        default:
          return state;
      }
    case "SET_CUSTODY":
      return processSetCustody(state, action.custody);

    case "SET_INITIALS_READONLY":
      return processSetInitialsReadOnly(state);
    case "CHANGE_FIELDS":
      return processChangeFields(state, action.fields);
    case "CHANGE_BUTTON_PROPS":
      return changeButtonProps(state, action);
    default:
      return state;
  }
};

function processSetCustody(state, custody) {
  const { mode } = state.ui;
  const readonly = {};
  if (mode == Mode.READONLY) {
    Object.keys(custody).forEach((f) => {
      readonly[f] = true;
    });
  }

  return mergeDeep(
    { ...state },
    {
      ui: {
        loading: false,
      },
      custody: {
        ...custody,
        actualstatus: custody.internalstatus,
      },
      fields: {
        readonly,
      },
      buttons: {
        precheck: { visible: mode != Mode.READONLY },
      },
    }
  );
}

function processChangeFields(state, fields) {
  const errors = Object.keys(fields).reduce((f, name) => {
    //f[name] = undefined;
    return f;
  }, {});
  return mergeDeep(
    { ...state },
    {
      custody: {
        ...fields,
      },
      fields: {
        errors,
      },
    }
  );
}

function processSetInitialsReadOnly(state) {
  return mergeDeep(
    { ...state },
    {
      fields: {
        readonly: {
          accountName: true,
          assetticker: true,
          volume: state.custody.internalstatus != CustodyIntStatus.ClientRequest,
          date: true,
        },
      },
    }
  );
}

function processEdit(state) {
  return mergeDeep(
    { ...state },
    {
      ui: {
        mode: Mode.EDIT,
      },
      buttons: {
        precheck: {
          visible: true,
          loading: false,
        },
        modify: {
          visible: false,
        },
        confirm: {
          visible: false,
          loading: false,
        },
      },
    }
  );
}

function processPrecheck(state) {
  const errors = validateForm(state);

  if (errors == false) {
    const readonly = {};

    Object.keys(state.custody).forEach((f) => {
      readonly[f] = true;
    });

    return mergeDeep(
      { ...state },
      {
        ui: {
          mode: Mode.PRECHECK,
        },
        buttons: {
          precheck: {
            loading: true,
          },
        },
        fields: {
          readonly,
        },
      }
    );
  } else {
    return mergeDeep(
      { ...state },
      {
        fields: {
          errors,
        },
      }
    );
  }
}

function processConfirm(state) {
  return mergeDeep(
    { ...state },
    {
      buttons: {
        precheck: {
          visible: false,
          loading: false,
        },
        modify: {
          visible: true,
        },
        confirm: {
          visible: true,
          loading: false,
        },
      },
    }
  );
}

function changeButtonProps(state, { props }) {
  return mergeDeep({ ...state }, { buttons: { ...props } });
}

export function validateForm(state) {
  const { custody, fields } = state;
  const { hiddens } = fields;
  const errors = {};

  const validations = validation(custody);

  Object.entries(validations).forEach((entry) => {
    const [name, value] = entry;

    if (!hiddens[name]) {
      if (value.empty) {
        if (custody[name] == undefined || custody[name] === "") {
          errors[name] = "Required field";
        } else if (value.autosuggestId && custody[value.autosuggestId] == undefined) {
          errors[name] = "Must select a value from list";
        } else if (!value.hasdenomination && custody[name] <= 0) {
          errors[name] = "the value must be positive";
        } else if (value.hasdenomination && custody[name].length != custody["volume"]) {
          errors[name] =
            "Must select " + parseInt(custody.volume) + " denominations for the volume selected.";
        }
      }
    }
  });

  // has Errors only add errors to state
  if (Object.keys(errors).length !== 0) {
    return errors;
  }

  return false;
}
